import { scrollToEls } from './global/scrollTo';
import headerInit from './sections/header/headerInit';
import cookieWarning from './dom/cookieWarning';
import { clickToggle } from './global/clickToggle';
// import preloadLinks from './dom/preloadPages';
import { initSort } from './sections/products/sort';
import initQuantitySelector from './sections/cart/quantitySelector';
import initInputValidator from './global/inputValidator';
import { glidify, initMOBSlider } from './dom/glidify';
import addToCartBtnInit from './sections/cart/addToCart';
import lazyloadify from './global/lazyload';
import { onShopifySectionLoad, ready } from './global/instantiate';
import initLoadMore from './sections/products/loadMore';
import { isInternetExplorer } from './dom/internetExplorerBodges';
import initModal from './components/modal';
import { initEventBus } from './global/eventBus';
import { initCountrySelector } from './sections/footer';
import initAccordion from './components/accordion';
import { blogAthlete, ambassadorShowMore } from './template/blog-athlete';
import {articleVideo, autoPlayOnDesktop} from './dom/articleVideo';
import productInitiativesScroll from './dom/productInitiativesScroll';
import { carouselInit } from './dom/carouselInit';
import { swipify, swipifyMob } from './dom/swipify';
import {
  initMailchimpAjaxSubmit,
  initNewsletterFlyout,
  initNewsletterPopup,
} from './sections/newsletterPopup';
import { collectionOfCollectionsNav } from './template/collection-of-collections';
import { initCountryRedirect } from './global/countryRedirect';
import { pressScroll } from './template/blog-press';
import { initCurrencySwitcher } from './sections/currencySwitcher';
import { initSubscriptionQuiz } from './sections/subscriptionQuiz';
import { initSubscriptionQuizResult } from './sections/subscriptionQuizResult';
import { redirectAfterRegistration } from './sections/account/redirectAfterRegistration';
import { initVimeoVideo } from './global/vimeoVideo';
import { initYoutubeVideo } from './global/youtubeVideo';
import headerSlide from './dom/headerSlide';
import bundleBuilder from './apps/bundleBuilder';
import { initUpsellsPopup } from './sections/upsellsPopup';
import { projectGreenSwiper } from './sections/product/projectGreen';
import { productInfoSwiper } from './sections/product/productInformation';
import { featureSwiper } from './sections/product/features'
import { stepsSwiper } from './sections/product/steps';
import { popularProductsSwiper } from './sections/footer-methods'
import { variantDetails } from './sections/product-new'

// @todo Would be nice to add to Baseline
const defaultWindowBlubolt = {
  turboLinksActive: false,
  glides: [],
  dom: {
    glidify,
    swipify,
    swipifyMob,
    // initFilters,
  },
}

// Helper functions
if (!window.blubolt) {
  window.blubolt = defaultWindowBlubolt
} else {
  window.blubolt = {...window.blubolt, ...defaultWindowBlubolt}
}

initEventBus();
ready(() => {
  lazyloadify();

  if (isInternetExplorer()) {
    return;
  }
  headerInit();
  clickToggle();
  headerSlide();
  initModal();
  // dismissablesInit();
  cookieWarning();
  initSort();
  initQuantitySelector();
  initInputValidator();
  scrollToEls();
  addToCartBtnInit();
  initLoadMore(() => {
    initMOBSlider();
    lazyloadify();
  });
  swipify();
  swipifyMob();
  glidify();
  initCountrySelector();
  initVimeoVideo();
  initYoutubeVideo();
  initAccordion();
  blogAthlete();
  ambassadorShowMore();
  articleVideo();
  autoPlayOnDesktop();
  productInitiativesScroll();
  carouselInit();
  collectionOfCollectionsNav();
  pressScroll()
  initNewsletterPopup();
  initNewsletterFlyout();
  initMailchimpAjaxSubmit();
  initUpsellsPopup();
  // Commenting for now as it affects crawlers.
  initCountryRedirect();
  initCurrencySwitcher();
  redirectAfterRegistration();
  initMOBSlider();
  initSubscriptionQuiz();
  initSubscriptionQuizResult();
  bundleBuilder();
  variantDetails();
  // if (preload) {
  //   preloadLinks();
  // }
});

onShopifySectionLoad(() => {
  headerInit();
  clickToggle();
  initQuantitySelector();
  lazyloadify();
  glidify();
  swipify();
  swipifyMob();
  initMOBSlider();
  initUpsellsPopup();
});
